import { store } from '../../store'
import { httpgst } from '../../main'

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/keywords/by-company/' + store.state.userLogged.company[0].id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let url = 'api/keywords'
    let params = {
      'company_id': payload.event.company.id,
      'gst_categories_id': payload.event.item.category,
      'keywords': payload.event.item.keywords
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({commit, dispatch}, payload) {
    let url = 'api/keywords/' + payload.event.item.id
    let params = {
      'company_id': payload.event.company.id,
      'gst_categories_id': payload.event.item.gst_categories_id,
      'keyword': payload.event.item.keyword
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({commit, dispatch}, payload) {
    let url = 'api/keywords/' + payload.event.company.id + '/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', { event: payload.event, response: response })
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let keywords = payload.response.data.data
    payload.event.context.keywords = keywords
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.close()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.close()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.close()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
      payload.event.context.loading = false
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/keywords.js